import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class GoogleMapsService {
	constructor(private http: HttpClient) {}
	private loader: Loader;

	/**
	 * Library information:
	 * https://developers.google.com/maps/documentation/javascript/overview#typescript_2
	 */
	loadGoogleMapsApi(): void {
		this.loader = new Loader({
			apiKey: environment.googleMapsApiKey,
			version: 'weekly'
		});

		this.loader
			.importLibrary('maps')
			.then(() => console.info('Loaded Google Maps API'))
			.catch(error => console.error('Error loading Google Maps API:', error));
	}
}
